import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { PhotoLightbox } from "@/components/site/foto/PhotoLightbox";
import type { PhotoItem } from "@/content/photo-gallery";

/**
 * Mobiloptimerat bildblock för ortssidor — samma princip som på
 * "För vem"-sidorna: bilder högt upp, kort text och en tydlig
 * bokningsknapp innan de långa SEO-styckena tar vid.
 */
export function LocalMobileGallery({
  photos,
  label,
  ctaTo,
  ctaLabel = "Boka 30 min – kostnadsfritt",
  heading = "Ett urval ur portfolion",
}: {
  photos: PhotoItem[];
  label: string;
  ctaTo: string;
  ctaLabel?: string;
  heading?: string;
}) {
  const items = photos.slice(0, 6);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  if (items.length === 0) return null;

  return (
    <section className="md:hidden">
      <div className="container-wide">
        <div className="flex items-baseline justify-between gap-3">
          <h2 className="text-xs uppercase tracking-[0.18em] text-mint">{label}</h2>
          <span className="text-xs text-foreground/60">{heading}</span>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-2">
          {items.slice(0, 4).map((p, i) => (
            <button
              key={p.id}
              type="button"
              onClick={() => setOpenIndex(i)}
              aria-label={`Öppna bild: ${p.alt}`}
              className="aspect-[4/5] overflow-hidden rounded-xl bg-surface"
            >
              <img
                src={p.src}
                width={p.w}
                height={p.h}
                alt={p.alt}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
              />
            </button>
          ))}
        </div>
        <a
          href={ctaTo}
          className="mt-4 flex items-center justify-center gap-2 rounded-full bg-peach px-5 py-3.5 text-[15px] font-semibold text-peach-foreground"
        >
          {ctaLabel}
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>
      <PhotoLightbox
        photos={items}
        index={openIndex}
        onClose={() => setOpenIndex(null)}
        onIndexChange={setOpenIndex}
      />
    </section>
  );
}
